// extracted by mini-css-extract-plugin
export default {"spacer":"MenuItemImage-module__spacer___psood","image":"MenuItemImage-module__image___PFK1Z","outOfStock":"MenuItemImage-module__outOfStock___MjVmP"};